import { fetchAuthenticatedForBlob } from './api';

export const onManual = async pdf => {
  try {
    const base64String = pdf.file.includes(',') ? pdf.file.split(',')[1] : pdf.file;

    fetch(`data:application/pdf;base64,${base64String}`)
      .then(res => res.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = pdf.name.endsWith('.pdf') ? pdf.name : `${pdf.name}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Error fetching and downloading PDF:', error));
  } catch (error) {
    console.error('Error processing Base64 PDF:', error);
  }
};

export const downloadPdfFromUrl = async (url: string, name: string, authenticated = false) => {
  const blob = authenticated ? await fetchAuthenticatedForBlob<Blob>(url) : await fetch(url).then(response => response.blob());

  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = name.endsWith('.pdf') ? name : `${name}.pdf`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
};
